import React from 'react'
import MiniHeader from '../MiniHeader'
import { useLocation } from 'react-router-dom'

function ServicePage() {
    const { state } = useLocation()
    return (
        <div>
            <MiniHeader isDisplayBack title={state?.title} noLoginIcon />
            <br />
            <div className='m-2 text-left' dangerouslySetInnerHTML={{ __html: state?.field_value }} />
        </div>
    )
}

export default ServicePage